import Swiper from 'swiper';
import { Navigation, A11y, FreeMode } from 'swiper/modules';
import sliderADA from '../../components/slider/ada';
// import { animate } from '../../core/animations';

const initSlider = (slider) => {
  new Swiper(slider, {
    modules: [ Navigation, A11y, FreeMode ], // https://swiperjs.com/swiper-api#using-js-modules
    a11y: {
      enabled: true,
      prevSlideMessage: window.theme.strings.swiperPrevSlide,
      nextSlideMessage: window.theme.strings.swiperNextSlide,
      containerMessage: window.theme.strings.swiperContainer,
    },
    slidesPerView: 2.2,
    slidesPerGroup: 1,
    spaceBetween: 8,
    loop: true,
    loopAddBlankSlides: false,
    autoHeight: false,
    freeMode: true,
    autoplay: false,
    breakpoints: {
      769: {
        slidesPerView: 4,
        slidesPerGroup: 1,
        spaceBetween: 8,
        freeMode: false,
        navigation: {
          nextEl: '.category-images .swiper-button-next',
          prevEl: '.category-images .swiper-button-prev',
        },
      },
    },
    on: {
      init: function () {
        // Swiper's a11y module sets aria-label on this container but not a
        // role, so on a plain <div> (implicit role="generic") the label is
        // silently ignored by assistive tech.
        this.el.setAttribute('role', 'region');
        sliderADA(slider);
      },
    }
  });
};

export default () => {
  // The swiper class gets added when there are more than 4 items
  const sliders = document.querySelectorAll('.category-images .swiper');

  if (sliders === null) {
    return;
  }

  sliders.forEach((slider) => {
    initSlider(slider);
  });
};
